// extracted by mini-css-extract-plugin
export default {"cabecalho":"cabecalho_cabecalho__ysgEu"};